import { useProductDetails } from 'journey/productDetails/provider';
import { isWearable } from 'shared/utils/wearable.utils';

interface UseWearableDeviceReturn {
  isBrandMatch: boolean;
  isWearable: boolean;
  isWearableEligibilityCheckRequired: boolean;
}

type UseWearableDeviceParameter = 'Apple' | 'Samsung' | 'Spacetalk' | undefined;

export default function useWearableDevice(
  brand?: UseWearableDeviceParameter,
): UseWearableDeviceReturn {
  const { selectedDevice } = useProductDetails();
  if (!selectedDevice) {
    return {
      isWearable: false,
      isWearableEligibilityCheckRequired: false,
      isBrandMatch: false,
    };
  }

  const { categoryIds, isEligibilityCheckRequired } = selectedDevice;

  const isWearableDevice = isWearable({ categoryIds });

  const isWearableEligibilityCheckRequired =
    isWearableDevice && isEligibilityCheckRequired;

  const isBrandMatch = selectedDevice?.brand === brand && isWearableDevice;

  return {
    isBrandMatch,
    isWearable: isWearableDevice,
    isWearableEligibilityCheckRequired,
  };
}
